export interface IPropertyHistoryResponseModel {
  CreateUserInfo?: {
    GroupID?: number;
    DepartmentId?: number;
    SiteId?: number;
    IsActive?: boolean;
    Id?: number;
    Name?: string;
    ShortName?: string;
    Email?: string;
    DirectPhone?: string;
    MobilePhone?: string;
    Photo?: string;
  };
  RootId?: number;
  Id?: number;
  Description?: string;
  Reference?: string;
  ShortName?: string;
  DateCreated?: string;
  DateModified?: string;
  Type?: number;
  TypeNameNL?: string;
  TypeNameFR?: string;
  TypeNameEN?: string;
  Icon?: number;
  Color?: number;
  Date?: string;
  Done?: boolean;
  ChildId?: number;
  DemandId?: number;
  TypeId?: number;
  HisDetailId?: number;
  CreateUserId?: number;
  ExcludeFromReport?: boolean;
  Status?: number;
	AppointmentIsException?: boolean;
	AppointmentIsRecurrence?: boolean;
	AppointmentMasterId?: number;
}
export class PropertyHistoryResponseModel implements IPropertyHistoryResponseModel {
  constructor() {
  }
}

export interface IPropertyHistoryProspectModel {
  Comments?: string;
  CompanyName?: string;
  CreateDate?: string;
  DateOffer?: string;
  DemandId?: number;
  Name?: string;
  NoInterestReason?: string;
  NoInterestReasonComment?: string;
  NoInterestReasonIds?: number[];
  NoInterestReasonInfo?: object;
  NoMoreInterest?: number;
  ObjectId?: number;
  Offer?: number;
  OfferEnd?: string;
  PersonId?: number;
  PriceEstimate?: number;
  Reference?: string;
  ReferenceProperty?: string;
  Relaunch?: number;
  children?: any;
  timelineVisible?: boolean;
}

export class PropertyHistoryProspectModel implements IPropertyHistoryProspectModel {
  Comments?: string;
  CompanyName?: string;
  CreateDate?: string;
  DateOffer?: string;
  DemandId?: number;
  Name?: string;
  NoInterestReason?: string;
  NoInterestReasonComment?: string;
  NoInterestReasonIds?: number[];
  NoInterestReasonInfo?: object;
  NoMoreInterest?: number;
  ObjectId?: number;
  Offer?: number;
  OfferEnd?: string;
  PersonId?: number;
  PriceEstimate?: number;
  Reference?: string;
  ReferenceProperty?: string;
  Relaunch?: number;
  children?: any;
  timelineVisible?: boolean;

  constructor(option?: IPropertyHistoryProspectModel) {
    Object.keys(option).forEach(key => this[key] = option[key]);

    this.Comments = this.Comments || "";
    this.DateOffer = this.DateOffer || null;
    this.NoInterestReason = this.NoInterestReason || "";
    this.NoInterestReasonComment = this.NoInterestReasonComment || "";
    this.NoInterestReasonIds = this.NoInterestReasonIds || [];
    this.OfferEnd = this.OfferEnd || null;
  }
}
